import {Vector3} from 'three';

import {checkExists} from 'external/dev_april_corgi+/js/common/asserts';
import {
  Controller,
  Response,
} from 'external/dev_april_corgi+/js/corgi/controller';
import {CLOSE} from 'external/dev_april_corgi+/js/emu/events';
import {SelectController} from 'external/dev_april_corgi+/js/emu/select_controller';

import {Graph} from './execution/graph';
import {NODE_SPECS} from './nodes/nodes';

import {loadGraphData} from './workspace_storage';

interface Args {
  graph: Graph;
  position: Vector3;
}

export interface State {
  graphs: Array<{id: string; name: string; lastModified: number}>;
}

type Deps = typeof AddSubgraphController.deps;

export class AddSubgraphController extends Controller<
  Args,
  Deps,
  HTMLElement,
  State
> {
  static deps() {
    return {
      controllers: {
        selection: SelectController,
      },
    };
  }

  private readonly graph: Graph;
  private readonly position: Vector3;
  private readonly selection: SelectController;

  constructor(response: Response<AddSubgraphController>) {
    super(response);
    this.graph = response.args.graph;
    this.position = response.args.position;
    this.selection = response.deps.controllers.selection;
  }

  async addSubgraph(): Promise<void> {
    const id = this.selection.value;
    const data = checkExists(loadGraphData(id));
    const subgraph = new Graph();
    subgraph.addBehaviors(NODE_SPECS);
    await subgraph.load(data.name, data.bytes, data.version);
    this.graph.addSubgraph(this.position, id, subgraph);
    this.trigger(CLOSE, {kind: 'resolve'});
  }
}
